<template>
  <span>
    {{ formatAndDisplaySocialNumber() }}
  </span>
</template>

<script>
import { formatSocialNumber } from '../../utils';

export default {
  props: {
    socialNumber: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    formatAndDisplaySocialNumber() {
      return formatSocialNumber(this.socialNumber);
    },
  },
};
</script>
